import React, { useContext } from 'react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import API from '../../../../../services/API'
import { GlobalContext } from '../../../../../App'

const NotLoggedIn = ({ employee }) => {
  const { setToast } = useContext(GlobalContext)
  const sendWelcomeEmail = () => {
    API.post('/employees/sendwelcomeemail', {
      userID: employee._id,
    }).then(
      (res) => res.status === 200 && setToast({ message: 'Welcome Email Sent' })
    )
  }
  if (!employee?.hasLoggedIn) {
    return (
      <Alert
        severity="info"
        variant="outlined"
        sx={{ backgroundColor: 'white' }}
        action={
          <Button
            onClick={() => sendWelcomeEmail()}
            size="small"
            color="info"
            variant="contained"
          >
            Send Welcome Email
          </Button>
        }
      >
        {employee.firstName} has not logged in yet.
      </Alert>
    )
  }
}

export default NotLoggedIn
